'use client'

import { ChevronUp } from 'lucide-react'
import { useEffect, useState } from 'react'

export const BackToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false)

  const toggleVisibility = () => {
    const scrolled = window.pageYOffset
    if (scrolled > 240) {
      setIsVisible(true)
    } else if (scrolled <= 240) {
      setIsVisible(false)
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility)
    return () => window.removeEventListener('scroll', toggleVisibility)
  }, [])
  return (
    isVisible && (
      <div
        onClick={scrollToTop}
        className='shadow-boxShadow_6 group fixed bottom-19 left-4 z-40 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-primary transition-all duration-150 ease-linear hover:bg-primary-400 sm:h-12 sm:w-12'
        id='back-to-top'
      >
        <ChevronUp className='sm:text-3.5xl text-base text-light' />
      </div>
    )
  )
}
